export function generateIdempotencyKey(
    aiAnalysisId: number,
    intent: string,
): string {
    const uuid = crypto.randomUUID();
    return `ai:${aiAnalysisId}:${intent.charAt(0).toUpperCase()}:${uuid}`;
}

export function intentToKeyChar(intent: 'FORWARD' | 'REVERSE' | 'MANUAL'): string {
    if ('FORWARD' === intent) return 'F';
    if ('REVERSE' === intent) return 'R';
    return 'M';
}
